import pdfMake from 'pdfmake/build/pdfmake.js';
import moment from 'moment';
import NumberToletters from './../../../../../utils/NumberToletters'
import { formatNumber } from '../../../../Utils/Money';

const generateDocDefTemplate2 = async (invoiceDetails, paymentDetails, startDate, endDate, radicationDate, contract) => {
    console.log("DATAPARAMS1", invoiceDetails)
    console.log("FECHAS: ", startDate, endDate, radicationDate)
    pdfMake.fonts = {
        OpenSans: {
            normal: 'OpenSans-Regular.ttf',
            bold: 'OpenSans-Bold.ttf',
            italics: 'OpenSans-Italic.ttf',
            bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        }
    };

    //let emision = moment(obj.fecha_emision).format('L');
    //let vencimiento = moment(obj.vencimiento).format('L');
    let invoices = [];
    for (let index = 0; index < invoiceDetails.length; index++) {
        const element = invoiceDetails[index];
        invoices.push(element.consecutivo);
    }
    let gotInvoices = invoices.filter((ele, pos) => invoices.indexOf(ele) == pos);



    let itemBody = [
        [
            {
                text: "Fecha",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "RAD",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "ID Paciente",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Paciente",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "CUPS",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Procedimiento",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Factura",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Recibo",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "V. Total",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Recuperación",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Entidad",
                style: "tableHeader",
                alignment: "center",
            },
        ],
    ];

    let itemBodyTotals = [];

    itemBodyTotals.push(
        [
            { text: 'Valor Facturado', alignment: "left", bold: true },
            { text: '$' + formatNumber(paymentDetails.valor_servicio_item), alignment: "left" }
        ],
        [
            { text: 'Recuperación', alignment: "left", bold: true },
            { text: '$' + formatNumber(paymentDetails.valor_copago_item), alignment: "left" }
        ],
        [
            { text: 'Entidad', alignment: "left", bold: true },
            { text: '$' + formatNumber(paymentDetails.valor_neto_item), alignment: "left" }
        ],
    );

    let itemBodyTotalsP = [];

    itemBodyTotalsP.push(
        [
            { text: 'Nro. Facturas', alignment: "left", bold: true },
            { text: '' + gotInvoices.length, alignment: "left" }
        ],
        [
            { text: 'Valor Facturado', alignment: "left", bold: true },
            { text: '$' + formatNumber(paymentDetails.valor_servicio_item), alignment: "left" }
        ],
        [
            { text: 'Recuperación', alignment: "left", bold: true },
            { text: '$' + formatNumber(paymentDetails.valor_copago_item), alignment: "left" }
        ],
        [
            { text: 'Notas Crédito', alignment: "left", bold: true },
            { text: '$0.0', alignment: "left" }
        ],
        [
            { text: 'Notas Debito', alignment: "left", bold: true },
            { text: '$0.0', alignment: "left" }
        ],
        [
            { text: 'Valor a Cobrar', alignment: "left", bold: true },
            { text: '$' + formatNumber(paymentDetails.valor_neto_item), alignment: "left" }
        ],
    );
    let itemArr = ["", "", "", "", "", "", "", "", "", ""];

    if (invoiceDetails.length === 0) {
        itemBody.push(itemArr)
    }

    for (let index = 0; index < invoiceDetails.length; index++) {
        const element = invoiceDetails[index];
        itemBody.push([
            { text: element.fecha, alignment: "left", style: 'textStyle' },
            { text: element.num_radicado, alignment: "left", style: 'textStyle' },
            { text: element.num_documento, alignment: "left", style: 'textStyle' },
            { text: element.nombre_paciente, alignment: "left", style: 'textStyle' },
            { text: element.cod_procedimiento, alignment: "left", style: 'textStyle' },
            { text: element.l_procedimiento, alignment: "left", style: 'textStyle' },
            { text: element.consecutivo, alignment: "left", style: 'textStyle' },
            { text: element.id_recibo, alignment: "left", style: 'textStyle' },
            { text: "$ " + formatNumber(element.valor_servicio_item), alignment: "left", style: 'textStyle' },
            { text: "$ " + formatNumber(element.valor_copago_item), alignment: "left", style: 'textStyle' },
            { text: "$ " + formatNumber(element.valor_neto_item), alignment: "left", style: 'textStyle' }
        ]);
    }


    pdfMake.tableLayouts = {
        exampleLayout: {
            hLineWidth: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                    return 1;
                }
                return i === node.table.headerRows ? 2 : 1;
            },
            vLineWidth: function (i) {
                return 1;
            },
            hLineColor: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                    return "black";
                }
                return i === 1 ? "black" : "#aaa";
            },
            fillColor: function (i, node) {
                return i === 0 ? "white" : i % 2 === 0 ? "#e8e8e8" : null;
            },
            paddingLeft: function (i) {
                return i === 0 ? 8 : 8;
            },
            paddingRight: function (i, node) {
                //return i === node.table.widths.length - 1 ? 0 : 8;
                return 3;
            },
            paddingTop: function (i, node) {
                return 3;
            },
            paddingBottom: function (i, node) {
                return 3;
            },
        },
    };

    var docDefinition = {
        pageSize: "LETTER",
        pageOrientation: "portrait",
        info: {
            title: "PDF S. RADICACIÓN",
            author: "",
        },
        header: function (currentPage, pageCount, pageSize) {
            return [
                {
                    canvas: [
                        {
                            type: "rect",
                            x: 0,
                            y: 10,
                            w: pageSize.width,
                            h: 3,
                            color: "#0069D9",
                        },
                    ],
                },
            ];
        },
        footer: function (currentPage, pageCount, pageSize) {
            return [
                {
                    canvas: [
                        {
                            type: "rect",
                            x: 0,
                            y: 0,
                            w: pageSize.width,
                            h: 5,
                            color: "#0069D9",
                        },
                    ],
                },
                {
                    text: "Pagina " + currentPage.toString() + " de " + pageCount + "   ",
                    alignment: "right",
                    margin: [0, 10, 30, 0],
                },
            ];
        },
        content: [
            {
                columns: [
                    {
                        width: "auto",
                        columns: [
                            {
                                image: await getBase64ImageFromURL(process.env.REACT_APP_PUBLIC_URL + "clinica/" + sessionStorage.getItem('id_clinica') + "/logo/" + sessionStorage.getItem('token')),
                                fit: [100, 50],
                            },
                        ],
                    },
                    {
                        width: "*",
                        text: [
                            {
                                text: "SOPORTE DE RADICACIÓN No.\n" + invoiceDetails[0].num_radicado,
                                fontSize: 15,
                                bold: true,
                                alignment: "right",
                                lineHeight: 1.2,
                            },
                            "\n",
                        ],
                    },
                ],
            },
            {
                text: "\n",
            },
            {
                alignment: "center",
                text: !!radicationDate ? "FECHA: " + radicationDate : "",
            },
            {
                alignment: "center",
                text: invoiceDetails[0].nit_tercero + " " + invoiceDetails[0].nombre_tercero,
            },
            {
                alignment: "center",
                text: contract?.regimen_nombre,
            },
            {
                text: "\n",
            },
            {
                alignment: "center",
                text: "PERIODO: " + moment(startDate,"DD/MM/YYYY").format('DD-MM-YYYY') + " A: " + moment(endDate,"DD/MM/YYYY").format('DD-MM-YYYY'),
            },
            {
                alignment: "center",
                bold: true,
                text: "DEBE A: " + "\n" + sessionStorage.getItem('nombre_empresa') + "\n" + sessionStorage.getItem('nit_empresa') + "\n" + sessionStorage.getItem('direccion_empresa') + "\n" + sessionStorage.getItem('telefono_emrpesa') + "\n",
            },
            {
                text: "\n\n",
            },
            "La suma de $ " + formatNumber(paymentDetails.valor_neto_item) + " ------------------------",
            NumberToletters(paymentDetails.valor_neto_item, {
                plural: 'pesos MCTE',
                singular: 'peso MCTE',
            }) + "\n",
            "Por concepto de: Prestacion de servicios de salud a pacientes",
            {
                text: "\n\n",
            },
            {
                style: "tableExample3",
                table: {
                    headerRows: 1,
                    widths: [120, 120],
                    //keepWithHeaderRows: 1,
                    body: itemBodyTotalsP,
                },
                alignment: "center",
                layout: "exampleLayout",
                dontBreakRows: true,
                relativePosition: { x: -10 }
            },
            {
                text: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n",
            },
            {
                canvas: [
                    { type: "line", x1: 0, y1: 0, x2: 300, y2: 0, lineWidth: 1 },
                ],
            },
            {
                text: "PROCESO DE FACTURACIÓN",
            },
            {
                text: "\n\n\n\n\n",
            },
            {
                width: "*",
                alignment: "center",
                text: [
                    {
                        text: "Dirección: " + sessionStorage.getItem('direccion_empresa') + "\n" + "Teléfono: " + sessionStorage.getItem('telefono_emrpesa') + "\n",
                        fontSize: 12,
                    },
                ],
            },
            {
                text: '',
                pageOrientation: 'landscape',
                pageBreak: 'before'
            },
            {
                columns: [
                    {
                        width: "auto",
                        columns: [
                            {
                                image: await getBase64ImageFromURL(process.env.REACT_APP_PUBLIC_URL + "clinica/" + sessionStorage.getItem('id_clinica') + "/logo/" + sessionStorage.getItem('token')),
                                fit: [100, 50],
                            },
                        ],
                    },
                    {
                        width: "*",
                        text: [
                            {
                                text: sessionStorage.getItem('nombre_empresa') + "\n" + sessionStorage.getItem('nit_empresa') + "\n" + sessionStorage.getItem('direccion_empresa') + "\n" + sessionStorage.getItem('telefono_emrpesa') + "\n",
                            },
                        ],
                    },
                    {
                        width: "*",
                        text: [
                            {
                                text: "RADICACIÓN",
                                fontSize: 15,
                                bold: true,
                                alignment: "right",
                                lineHeight: 1.2,
                            },
                            "\n",
                        ],
                    },
                ],
            },
            {
                text: "\n",
            },
            {
                canvas: [
                    { type: "line", x1: 0, y1: 0, x2: 700, y2: 0, lineWidth: 1 },
                ],
            },
            {
                text: "\n",
            },
            {
                text: "REPORTE DE PRESTACIÓN DE SERVICIOS PRESTADOS\n", bold: true, alignment: "center"
            },
            {
                text: invoiceDetails[0].nit_tercero + " " + invoiceDetails[0].nombre_tercero, alignment: "center"
            },
            {
                style: "tableExample",
                table: {
                    headerRows: 1,
                    width: "*",
                    //keepWithHeaderRows: 1,
                    body: itemBody,
                },
                layout: "exampleLayout",
                dontBreakRows: true,
            },
            {
                style: "tableExample",
                table: {
                    headerRows: 1,
                    widths: [120, 120],
                    //keepWithHeaderRows: 1,
                    body: itemBodyTotals,
                },
                layout: "exampleLayout",
                dontBreakRows: true,
                relativePosition: { x: -10 }
            }
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                margin: [0, 0, 0, 10],
            },
            subheader: {
                fontSize: 16,
                bold: true,
                margin: [0, 10, 0, 5],
            },
            tableExample: {
                fontSize: 10,
                margin: [0, 15, 0, 80],
            },
            tableHeader: {
                bold: true,
                fontSize: 10,
                color: "black",
            },
            textStyle: {
                fontSize: 9,
            },
        },
        defaultStyle: {
            columnGap: 15,
        },
    };

    const pdfDocGenerator = pdfMake.createPdf(docDefinition);
    pdfDocGenerator.getDataUrl(function (outDoc) {
        document.getElementById('pdfV').src = outDoc;
    });
};

const getBase64ImageFromURL = (url) => {
    return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var dataURL = canvas.toDataURL("image/png");

            resolve(dataURL);
        };

        img.onerror = error => {
            reject(error);
        };

        img.src = url;
    });
}

export default generateDocDefTemplate2;